<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Editar link</h5>
    <div mat-dialog-content>
        <!--begin::Form-->
        <form class="form" [formGroup]="editLinkForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div class="form-group">
            <br-alert *ngIf="showAlert"></br-alert>
            <p><strong>ID: </strong>{{linkData.id}}</p>
            <p><strong>Fecha de creación: </strong>{{linkData.createdAt | date: 'MMMM d, y'}}</p>
            <mat-form-field class="w-100">
                <mat-label>Nombre</mat-label>
                <input matInput type="text"
                    formControlName="name" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('name', 'required')">
                    <strong>Campo requerido</strong>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label>Link</mat-label>
                <input matInput type="text"
                    formControlName="link" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('link', 'required')">
                    <strong>Campo requerido</strong>
                </mat-error>
            </mat-form-field>
        </div>
        </form>
        <!--end::Form-->
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick(false)">Cerrar</button>
        <button mat-button cdkFocusInitial (click)="submit(editLinkForm)">Guardar</button>
    </div>
</div>